import * as React from "react";
import { Slot as RadixSlot, SlotProps as RadixSlotProps } from "@radix-ui/react-slot";

/**
 * A wrapper for Radix UI's Slot component that helps prevent
 * "Function components cannot be given refs" warnings.
 * 
 * This component serves as a safer replacement for the original Slot.
 */
const SafeSlot = React.forwardRef<HTMLElement, RadixSlotProps>((props, ref) => {
  return <RadixSlot {...props} ref={ref} />;
});

SafeSlot.displayName = 'SafeSlot';

// Export the safe slot component
export { SafeSlot as Slot };
export type { RadixSlotProps as SlotProps };

// Also export the original component for reference
export { RadixSlot as OriginalSlot };
